import React from "react";

class GitProfile extends React.Component {
     constructor(props) {
          super(props);
          this.state = {
               userInfo: {
                    name: "null",
                    id: 0,
                    avatar_url: "null",
               }
          };
          console.log("constructor");
     }

     async componentDidMount() {
          //api call can be done inside this
          console.log("componentdidmount");
          const data = await fetch("https://api.github.com/users/saurabhsingh720");
          const json = await data.json();
          this.setState({
               userInfo: json,
          });
          console.log(json);
     }

     render() {

          return (
               <div
                    //     className="gitmain"
                    className="flex items-center justify-center m-2">
                    <div // className="gitin"
                         className=" justify-center">
                         <div /* className="gitImg" */ className="m-4 p-0">
                              <img src={this.state.userInfo.avatar_url}
                                   className="w-auto h-42 rounded-full shadow-2xl " alt="" /></div>
                         <div className="m-2 p-2 items-center justify-around border border-indigo-600 rounded-lg border-b-orange-50" >ID: {this?.state?.userInfo?.id}</div>
                         <div className="m-2 p-2 items-center justify-around border border-indigo-600 rounded-lg border-b-orange-50">UserName: {this?.state?.userInfo?.login}</div>
                         <div className="m-2 p-2 items-center justify-around border border-indigo-600 rounded-lg border-b-orange-50">Bio: {this?.state?.userInfo?.bio}</div>
                    </div>
               </div>
          )
     }
}
export default GitProfile;